'use strict';

var RomSummaryResTypeChartFilterFactory = function RomSummaryResTypeChartFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['ROMOptGroupWeekFilterFactory', 'ROMSummaryCabinFilterFactory', 'ROMSummaryPOSFilterFactory', 'ROMSummaryDOWFilterFactory', 'ROMSummaryRomTimeBucketFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function RomSummaryResTypeChartFilter() {
    DemandFilter.call(this, 'rom-summary-mode', 'res-type-thematic-chart');
    this.registerFilters(injectedFilters);
  }
  RomSummaryResTypeChartFilter.constructor = RomSummaryResTypeChartFilter;
  RomSummaryResTypeChartFilter.prototype = Object.create(DemandFilter.prototype);
  return RomSummaryResTypeChartFilter;
};
RomSummaryResTypeChartFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = RomSummaryResTypeChartFilterFactory;